import orderInstance from '../instance'

const updatePayer = (orderId, data) => {
	return orderInstance.put(`/orders/${orderId}/payer`, data)
}

export default updatePayer
